// The distinct categorical values (position/league/club/nationality/foot) across the whole
// population — what a value-picker lists. Computed once from the snapshot (the engine's
// getFilterOptions is pure/data-injected). Shared by every chip-bar consumer (Rankings,
// Filter, Stats). The snapshot site only: with ?live=1 the chips list the group file's values
// (live/group-players.ts), so this is empty there (no snapshot players).

import { useMemo } from "react";
import { snapshotPlayersOrNone } from "../data/snapshot.js";
import { getFilterOptions, type KitPlayer } from "../engines/stats-filter-kit.js";

export function useFilterOptions(): Record<string, string[]> {
  return useMemo(
    () => getFilterOptions(Object.values(snapshotPlayersOrNone()) as unknown as KitPlayer[]),
    [],
  );
}
